module.exports = __webpack_public_path__ + "static/media/mic-24px.58e127e9.svg";